export default __webpack_public_path__ + "static/media/doc-small-white.db61a8ee.svg";